import styles from "./Header.module.css";

export const Header = ({ openModal, openLogout, user }) => {
  let authBlock;

  if (user) {
    authBlock = (
      <button
        type="button"
        className={styles["header-singup"]}
        onClick={openLogout}
      >
        {user.username}
      </button>
    );
  } else {
    authBlock = (
      <button
        type="button"
        className={styles["header-singup"]}
        onClick={openModal}
      >
        Sign Up
      </button>
    );
  }

  return (
    <header>
      <div className="container">
        <div className={styles["header-container"]}>
          <img src="./images/24-forecast.svg" alt="24-forecast" />

          <ul className={styles["header-list"]}>
            <li>
              <a href="#footer" className={styles["header-share"]}>
                Who we are
              </a>
            </li>
            <li>
              <a href="#footer" className={styles["header-share"]}>
                Contacts
              </a>
            </li>
            <li>
              <a href="#hero" className={styles["header-share"]}>
                Menu
              </a>
            </li>
          </ul>

          <div className={styles["header-mincont"]}>{authBlock}</div>

          <img
            className={styles["header-us"]}
            src="./images/user.svg"
            alt="user"
          />
        </div>
      </div>
    </header>
  );
};
